// ModalContext.js
import React from 'react';

const GoogleMapContext = React.createContext();

export default GoogleMapContext;
